import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { Button } from "@/web/components/primitives/button";

export function ErrorFallback({ error, reset }: { error: unknown; reset?: () => void }) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  const message = error instanceof Error ? error.message : "An unexpected error occurred.";

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-6 py-10">
      <div className="w-full max-w-xl border border-border bg-card p-8 shadow-sm">
        <p className="font-mono text-muted-foreground">Fatal error</p>
        <h1 className="mt-2 font-mono text-2xl">We hit a snag...</h1>
        <p className="mt-3 font-mono text-muted-foreground">
          Please try again. If the issue keeps happening, refresh the page or come back in a minute.
        </p>
        <div className="mt-6 flex gap-3">
          {reset && <Button onClick={reset}>Try again</Button>}
          <Button variant="outline" onClick={() => window.location.reload()}>
            Refresh page
          </Button>
        </div>
        <p className="mt-6 font-mono text-muted-foreground">Error message:</p>
        <pre className="mt-6 overflow-auto border border-border bg-muted p-3 text-xs whitespace-pre-wrap">
          {message}
        </pre>
      </div>
    </div>
  );
}
